import { ucFirst } from "../Services/helpers";

const dateRanges = {
    'allTime'         : 'All time',
    'tax2425'         : 'Tax year 2024/25',
    'tax2526'         : 'Tax year 2025/26',
    // 'tax2627'         : 'Tax year 2026/27',
    'lastYear'        : 'Last Year',
    'thisYear'        : 'This Year',
    'lastMonth'       : 'Last Month',
    'thisMonth'       : 'This Month',
    'lastTwelveMonths': 'Last 12 Months',
    'lastSixMonths'   : 'Last 6 Months',
    'lastThreeMonths' : 'Last 3 Months',
    'lastWeek'        : 'Last Week',
    'thisWeek'        : 'This Week',
    'yesterday'       : 'Yesterday',
    'today'           : 'Today',
}

const futureDateRanges = {
    'thisYear'        : 'This Year',
    'nextYear'        : 'Next Year',
    'nextTwelveMonths': 'Next 12 Months',
    'nextThreeMonths' : 'Next 3 Months',
    'thisMonth'       : 'This Month',
    'nextMonth'       : 'Next Month',
    'nextWeek'        : 'Next Week',
    'tomorrow'        : 'Tomorrow',
}

const periods = [
    'date',
    'week',
    'month',
    'year',
];

const selectableDateRanges = Object.keys(dateRanges).map(key => ({
    value: key,
    label: dateRanges[key],
}));

const selectableDateRangesWithoutDays = Object.keys(dateRanges)
    .filter(key => !['yesterday', 'today', 'tomorrow'].includes(key))
    .map(key => ({
        value: key,
        label: dateRanges[key],
    }));

const selectableDateRangesQuick = ['lastThreeMonths', 'lastSixMonths', 'lastTwelveMonths', 'thisMonth', 'lastMonth', 'thisYear']
    .map(key => ({
        value: key,
        label: dateRanges[key],
    }));

const selectableInvoiceDateRanges = ['allTime', 'lastYear', 'thisYear', 'thisMonth', 'lastMonth', 'lastThreeMonths', 'thisWeek', 'lastWeek']
    .map(key => ({
        value: key,
        label: dateRanges[key],
    }));

const selectableFutureDateRanges = Object.keys(futureDateRanges).map(key => ({
    value: key,
    label: futureDateRanges[key],
}));

const selectablePeriods = periods.map(key => ({
    value: key,
    label: ucFirst(key),
}));

export {
    dateRanges,
    selectableDateRanges,
    selectableDateRangesWithoutDays,
    selectableDateRangesQuick,
    selectableFutureDateRanges,
    selectableInvoiceDateRanges,
    periods,
    selectablePeriods,
};
